import { gql } from "@apollo/client";

export const groupDetailsListItemV2Fragment = gql`
    fragment GroupDetailsListItemV2 on GroupWithConnections {
        group {
            name
            id
            description
            totalNumLenses
            readOnly
            isPinned
            status
            updatedAt {
                seconds
            }
        }
        connections {
            connectionId
            lens {
                compoundId {
                    id
                    reference
                    lensSourceType
                }
                iconUrl
                name
                removed
                lensSourceInfo {
                    name
                }
            }
            priority
        }
    }
`;
